import React, { useState, useEffect } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import {
  ADMIN_DASHBOARD_PATH,
  ADMIN_USERS_PATH,
  ADMIN_AGENCIES_PATH,
  ADMIN_REQUESTS_PATH,
  ADMIN_SERVICE_REQUESTS_PATH,
  AGENCY_INSTRUCTIONS_PAGE,
} from '../../../utils/AppRoutes';
import { Link, useLocation } from 'react-router-dom';
const AdminSidebar = (propd) => {
  //State
  const [activeMenu, setActiveMenu] = useState('dashboard');

  //Did Mount
  let location = useLocation();

  useEffect(() => {
    let currentMenuToActive = window.location.pathname.split('/')[2] || '/';
    // console.log('Route ', currentMenuToActive);
    setActiveMenu(currentMenuToActive);
  }, [location]);

  return (
    <div className="side-bar pt-3">
      <ul>
        <NavItem
          className={['dashboard', '/'].includes(activeMenu) ? 'active' : ''}
        >
          <Link to={ADMIN_DASHBOARD_PATH}>
            <NavLink>
              <i className="fas fa-tachometer-alt" /> Dashboard
            </NavLink>
          </Link>
        </NavItem>
        <NavItem className={activeMenu === 'admins' ? 'active' : ''}>
          <Link to={ADMIN_USERS_PATH}>
            <NavLink>
              <i className="fas fa-user-friends" /> Admins
            </NavLink>
          </Link>
        </NavItem>
        <NavItem
          className={
            ['agencies', 'agency'].includes(activeMenu) ? 'active' : ''
          }
        >
          <Link to={ADMIN_AGENCIES_PATH}>
            <NavLink>
              <i className="fas fa-users" /> Agencies
            </NavLink>
          </Link>
        </NavItem>
        <NavItem className={activeMenu === 'requests' ? 'active' : ''}>
          <Link to={ADMIN_REQUESTS_PATH}>
            <NavLink>
              <i className="fas fa-file"></i> Document Requests
            </NavLink>
          </Link>
        </NavItem>
        <NavItem className={activeMenu === 'serviceRequests' ? 'active' : ''}>
          <Link to={ADMIN_SERVICE_REQUESTS_PATH}>
            <NavLink>
              <i className="far fa-id-badge"></i>Service Requests
            </NavLink>
          </Link>
        </NavItem>
      </ul>
    </div>
  );
};
export default AdminSidebar;
